<template>
  <div class="r-text-body-small">
    <div class="r-text-intro">אישורים והצהרות</div>
    <div class="r-text-headline-paragraph">
      <div>בשביל לסיים, צריך לענות על</div>
      <div>הסעיפים הבאים. זה קצת</div>
      <div>מעיק, אבל זה חשוב.</div>
    </div>

    <div class="section">
      <div class="title r-text-intro">1 - מיסוי</div>
      <call-to-action-frame>
        <tax :is-usa-resident="isUsaResident"
             :is-paying-usa-tax="isPayingUsaTax"
             :is-oecd="isOecd"
             @input:usa-resident="setIsUsaResident"
             @input:paying-usa-tax="setIsPayingUsaTax"
             @input:oecd="setIsOecd"
             @observe="observe" />
      </call-to-action-frame>

    </div>

    <div class="section">
      <div class="title r-text-intro">2 - הצהרת נהנה</div>
      <call-to-action-frame>
        <beneficiary
          :beneficiary-choice="beneficiaryChoice"
          :beneficiaries="beneficiaries"
          :beneficiary-unknown-reason="beneficiaryUnknownReason"
          @observe="observe"
          @beneficiary-changed="setBeneficiary"
          @beneficiary-choice="setBeneficiaryChoice"
          @beneficiary-unknown-reason="setBeneficiaryUnknownReason" />
      </call-to-action-frame>
    </div>

    <div class="section">
      <div class="title r-text-intro">3 - אישורים</div>
      <call-to-action-frame>
        <validate :validated-value="assignPowerOfAttorney" :validations="{ required: { allowFalse: false }}" @observe="observe">
          <assign-power-of-attorney :assign-power-of-attorney="assignPowerOfAttorney" @input="setAssignPowerOfAttorney"/>
        </validate>

        <r-separator spaced/>

        <validate :validated-value="agreeToTermsAndConditions" :validations="{ required: { allowFalse: false }}" @observe="observe">
          <agree-terms-and-conditions :agree-to-terms-and-conditions="agreeToTermsAndConditions" @input="setAgreeToTermsAndConditions"/>
        </validate>

        <r-separator spaced/>

        <validate :validated-value="agreeLegalConditions" :validations="{ required: { allowFalse: false }}" @observe="observe">
          <agree-legal-conditions
            :agree-legal-conditions="agreeLegalConditions"
            @input="setAgreeLegalConditions" />
        </validate>

        <r-separator spaced/>

        <agree-to-receive-mail
          :agree-to-receive-mail-from-meitav="agreeToReceiveMailFromMeitav"
          @input="setAgreeToReceiveMailFromMeitav" />

        <r-separator spaced/>

        <div>
          <validate validations="required" :validated-value="mailingChannel" @observe="observe">
            <select-mailing-channel :mailing-channel="mailingChannel" @input="setMailingChannel"/>
          </validate>
        </div>
      </call-to-action-frame>
    </div>

    <div class="section">
      <div class="title r-text-intro">4 - החתימה שלך</div>
      <call-to-action-frame>
        <signature-with-validation @observe="observe" @signed="setSignature" />
      </call-to-action-frame>
    </div>

    <default-button label="אישור" @click="validateAndProceed" :disable="locked" :loading="locked" />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import Beneficiary from '@/components/meitav-dash/open-fund/statements/Beneficiary';
import DefaultButton from '@/components/styled/DefaultButton';
import SelectMailingChannel from '@/components/meitav-dash/open-fund/statements/SelectMailingChannel';
import Validate from '@/components/helpers/Validate';
import CallToActionFrame from '@/components/styled/CallToActionFrame';
import RSeparator from '@/components/base/RSeparator';
import AgreeToReceiveMail from '@/components/meitav-dash/open-fund/statements/AgreeToReceiveMail';
import AgreeLegalConditions
  from '@/components/meitav-dash/open-fund/statements/AgreeLegalConditions';
import AssignPowerOfAttorney
  from '@/components/meitav-dash/open-fund/statements/AssignPowerOfAttorney';
import AgreeTermsAndConditions
  from '@/components/meitav-dash/open-fund/statements/AgreeTermsAndConditions';
import Tax from '@/components/meitav-dash/open-fund/statements/Tax';
import TaxStateNotSupportedHelper
  from '@/views/meitav-dash/open-fund/dialogs/TaxStateNotSupportedHelper';
import SignatureWithValidation from '@/components/SignatureWithValidation';

export default {
  name: 'Statements',
  components: {
    SignatureWithValidation,
    Tax,
    AgreeTermsAndConditions,
    AssignPowerOfAttorney,
    AgreeLegalConditions,
    AgreeToReceiveMail,
    RSeparator,
    CallToActionFrame,
    Validate,
    SelectMailingChannel,
    DefaultButton,
    Beneficiary,
  },
  mixins: [WizardPage, TaxStateNotSupportedHelper],
  computed: {
    ...mapState('meitavDash/openFund', [
      'beneficiaryChoice',
      'beneficiaryUnknownReason',
      'agreeLegalConditions',
      'agreeToReceiveMailFromMeitav',
      'assignPowerOfAttorney',
      'agreeToTermsAndConditions',
      'mailingChannel',
      'beneficiaries',
      'isUsaResident',
      'isPayingUsaTax',
      'isOecd',
      'signature',
    ]),
  },
  methods: {
    ...mapActions('meitavDash/openFund', ['setBeneficiaryChoice']),
    ...mapMutations('meitavDash/openFund', [
      'setAgreeLegalConditions',
      'setAgreeToReceiveMailFromMeitav',
      'setAssignPowerOfAttorney',
      'setAgreeToTermsAndConditions',
      'setMailingChannel',
      'setSignature',
      'setBeneficiary',
      'setBeneficiaryUnknownReason',
      'setIsUsaResident',
      'setIsPayingUsaTax',
      'setIsOecd',
    ]),
    async validateAndProceed() {
      if (this.shouldShowTaxStateNotSupportedDialog) {
        this.openTaxNotSupportedDialog();
        return;
      }
      await this.nextPage();
    },
  },
};
</script>

<style scoped lang="scss">

.section {
  margin-bottom: 16px;

  .title {
    margin-bottom: 16px;
  }
}

.riseup-terms-and-conditions {
  width: 100%;
}

</style>
